import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: { user: null },
  reducers: {
    addUser(state, action) {
      state.user = action.payload;
    },
    updateProfile(state, action) {
      state.user.profileUrl = action.payload;
    },
    logout(state, action) {
      state.user = null;
    },
  },
});

export const { addUser, updateProfile, logout } = userSlice.actions;
export default userSlice.reducer;
